import angular from 'angular';

import portalCommonModule from 'portal/common';
import constantsModule from './constants';
import linksModule from './links';
import uiModule from './ui';
import servicesModule from './services';

export default angular.module('fp:customerportal:shop:common', [
    portalCommonModule.name,
    constantsModule.name,
    linksModule.name,
    uiModule.name,
    servicesModule.name
]);